<template>
  <div>
    <!-- 上排LOGO -->
    <MemberHeader/>
    <router-view class="member_router_view"></router-view>
  </div>
</template>
<script>
import MemberHeader from '@/components/base/MemberHeader'
export default {
  name: "Member",
  components: {
    'MemberHeader': MemberHeader,
  },
}
</script>
<style>
  .member_router_view{
    margin: 76px 0 0 300px;
    min-height: calc(100vh - 76px);
    background: rgba(0, 0, 0, 0.07);
    display: flex;
    flex-direction: column;
    justify-content: space-between
  }
  @media(max-width: 992px){
    .member_router_view{
      margin: 76px 0 0 200px;
    }
  }
  @media(max-width: 768px){
    .member_router_view{
      margin: 76px 0 0 0;
    }
  }
</style>